import { Moon, Sun } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import { useTheme } from "@/components/ThemeProvider";
import { useAppStore } from "@/stores/appStore";

export function ModeToggle() {
  const { setTheme } = useTheme();
  const { effectiveTheme } = useAppStore();
  const [isFading, setIsFading] = useState(false);

  const handleClick = () => {
    setIsFading(true);
    const next = effectiveTheme === "light" ? "dark" : "light";
    setTimeout(() => {
      setTheme(next);
      setIsFading(false);
    }, 150);
  };

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={handleClick}
      title={`Theme: ${effectiveTheme}`}
      className={`transition-opacity duration-300 ease-in-out ${
        isFading ? "opacity-0" : "opacity-100"
      }`}
    >
      <Sun className="absolute h-[1.2rem] w-[1.2rem] scale-100 rotate-0 transition-all dark:scale-0 dark:-rotate-180" />
      <Moon className="absolute h-[1.2rem] w-[1.2rem] scale-0 rotate-90 transition-all dark:scale-100 dark:rotate-0" />
      <span className="sr-only">Toggle theme</span>
    </Button>
  );
}
